import React from 'react';
import update from 'immutability-helper';
import { withRouter } from 'react-router-dom';

import { sendRequest, triggerEvent } from '../helpers/global.js';

import ObjectEditInput from './common/ObjectEditInput';
import { stateToHtml } from './input/WysiwygInput';

import '../sass/components/ObjectEditView.scss';

class ObjectEditView extends React.Component {

  constructor(props) {
    super(props);
    this.state = this.getDefaultState(props);
  }

  paramId = () => {
    const id = this.props.match.params.id;
    return id === 'create' ? '' : id;
  }

  getDefaultState = (props) => {
    const { properties, config } = this.props.config;
    let object = {};
    Object.keys(properties).forEach(key => {
      if (key === 'id') {
        object[key] = isNaN(this.paramId()) ? this.paramId() : Number(this.paramId());
      } else if (props.object && props.object[key]) {
        object[key] = props.object[key];
      } else {
        if (properties[key].default === null) {
          object[key] = properties[key].default;
        } else if (Array.isArray(properties[key].default)) {
          object[key] = properties[key].default.slice();
        } else if (typeof properties[key].default === 'object') {
          object[key] = Object.assign({}, properties[key].default);
        } else {
          object[key] = properties[key].default;
        }
      }
    });
    let state = {
      object: object,
      properties: properties,
      config: config,
      errors: {},
      dataReceived: false,
    }
    return state;
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.configKey) {
      if (this.props.location !== prevProps.location) {
        this.setState(this.getDefaultState(this.props), () => {
          this.requestInitialData();
        });
      }
    }
  }

  updateStateWithData = (data) => {
    const properties = this.state.properties;
    let object = {...this.state.object, ...data};
    Object.keys(properties).forEach(key => {
      if (object[key] === undefined || object[key] === null) {
        object[key] = properties[key].default || null;
      }
    });
    this.setState({ object, dataReceived: true });
  }

  componentDidMount = () => {
    this.requestInitialData();
  }

  requestInitialData = () => {
    if (!this.paramId()) {
      this.setState({dataReceived: true});
      return;
    }
    sendRequest({
      method: this.state.config.method + this.paramId(),
      type: 'GET',
      success: (data) => {
        this.updateStateWithData(data);
      },
      error: (data) => {
      }
    });
  }

  onCancel = () => {
    this.props.history.goBack();
  }

  handleSubmit = () => {
    let data = {};
    let formDataRequired = false;
    Object.keys(this.state.object).forEach(key => {
      const value = this.state.object[key];
      const properties = this.state.properties[key];
      if (!properties) {
      } else if (value === null || value === undefined) {
        if (properties.type === 'select' && properties.type === 'multi-select') {
          data[key] = null;
        }
      } else if (['image', 'file'].indexOf(properties.type) > -1) {
        if (typeof value !== 'string') {
          data[key] = value;
          formDataRequired = true;
        }
      } else if (properties.type === 'wysiwyg') {
        data[key] = stateToHtml(value);
      } else if (properties.type === 'file-upload') {
        if (typeof value === 'object') {
          if (value.removed) {
            data[key] = null;
          } else if (value.uploaded) {
            data[key] = value.uploaded;
          }
        }
      } else {
        data[key] = value;
        formDataRequired = true;
      }
    });

    let formData = null;
    if (formDataRequired) {
      formData = new FormData();
      Object.keys(data).forEach(key => {
        formData.append(key, data[key]);
      })
    }

    sendRequest({
      method: this.state.config.method + this.paramId(),
      type: this.paramId() ? 'PUT' : 'POST',
      data: formDataRequired ? null : data,
      formData, 
      success: (data) => {
        if (data.id) {
          this.updateStateWithData(data);
          this.props.history.goBack();
          triggerEvent('showSnackbar', [{text: `${this.state.config.objectName} saved`}]);
        } else if (data.errors) {
          this.setState({errors: data.errors}, this.scrollIntoError);
        }
      },
      error: (data) => {
        if (data.errors) {
          this.setState({errors: data.errors}, this.scrollIntoError);
        }
      }
    });
  }

  handleValueChange = (key, value) => {
    this.setState(update(this.state, {
      object: {
        [key]: {$set: value},
      },
      errors: {
        [key]: {$set: null},
      },
    }));
  }

  scrollIntoError = () => {
    const keys = Object.keys(this.state.errors);
    if (keys[0]) {
      const elem = document.querySelector(`#input-${keys[0]}`);
      if (elem) {
        elem.scrollIntoView({behavior: 'smooth', block: 'center'});
      }
    }
  }

  renderInput = (key, extendProperties) => {
    const inputProperties = {...this.state.properties[key], ...extendProperties};
    return (
      <ObjectEditInput
        key={key}
        inputKey={key}
        object={this.state.object}
        onChange={this.handleValueChange}
        error={this.state.errors[key]}
        inputProperties={inputProperties}
        readOnly={this.state.config.readOnly}
      />
    )
  }

  render = () => {
    if (!this.state.dataReceived) {
      return null;
    }

    const { modifyCondition, readOnly, createOnly, bottomControls = [], editView } = this.state.config;
    let showActionButton = true;
    if (readOnly || this.state.object.deleted || (createOnly && this.state.object?.id)) {
      showActionButton = false;
    }
    if (modifyCondition && !modifyCondition(this.state.object)) {
      showActionButton = false;
    }

    return (
      <div className='objectEditView'>

      <div className='pageTitle'>
        <span className='backLink' onClick={this.onCancel}>
          <span className='material-icons'>keyboard_backspace</span>
        </span>
        {this.state.config.objectName}
      </div>
      
      {editView ? <>
        {React.createElement(editView, {
          item: this.state.object,
          errors: this.state.errors,
          onChange: this.handleValueChange,
          onError: errors => this.setState({errors}, this.scrollIntoError),
          renderInput: this.renderInput,
        })}
        {showActionButton ?
          <div className='buttonContainer left'>
            <button onClick={this.onCancel} className='outline'>Отмена</button>
            <button onClick={this.handleSubmit}>Сохранить</button>
          </div>
        : null}
      </> :
        <div className='card'>
          {this.state.config.sections
            ? this.state.config.sections.map((section, index) =>
              <div key={index} className='inputSection'>
                {section.title ?
                  <div className='sectionTitle'>
                    {section.title}
                    {section.checkboxField ? this.renderInput(section.checkboxField, {title: null}) : null}
                  </div>
                : null}
                {section.checkboxField && !this.state.object[section.checkboxField] ? null :
                  <div className='inputsBlock'>
                    {section.fields?.map(this.renderInput)}
                  </div>
                }
              </div>
            )
            : <div className='inputsBlock'>
              {Object.keys(this.state.properties).map(this.renderInput)}
            </div>
          }
          {showActionButton ?
            <div className='buttonContainer'>
              <button onClick={this.onCancel} className='outline'>Отмена</button>
              <button onClick={this.handleSubmit}>Сохранить</button>
            </div>
          : null}
        </div>
      }

        {bottomControls.map((control, i) =>
          React.createElement(control, {
            key: i,
            item: this.state.object,
            onChange: object => this.setState({object}),
          })
        )}

      </div>
    );
  }
}

export default withRouter(ObjectEditView);
